import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';
import Image from '../Image';
import Text from '../Text';
import Heading from '../Heading';

export default class CircledImage extends Component {
  static propTypes = {
    isGrey: PropTypes.bool,
    src: PropTypes.string.isRequired,
    height: PropTypes.string,
    width: PropTypes.string,
    name: PropTypes.string,
    title: PropTypes.string,
    tinySrc: PropTypes.string,
    alt: PropTypes.string.isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    height: '180px',
    width: '180px',
    className: '',
  };

  render() {
    const { isGrey, src, height, width, name, title, alt, tinySrc, className } = this.props;

    return (
      <div className={styles.circledImageContainer}>
        <Image
          src={src}
          height={height}
          width={width}
          className={classNames(className, {
            [styles.grey]: isGrey,
          })}
          alt={alt}
          tinySrc={tinySrc}
        />
        <div className={styles.circledImageText}>
          <div>
            <Heading className={styles.name} level={6}>
              {name}
            </Heading>
          </div>
          <div className={styles.title}>
            <Text>{title}</Text>
          </div>
        </div>
      </div>
    );
  }
}
